// src\themes\lino\elements\footer\Footer.tsx
import Image from 'next/image';
import Link from 'next/link';

import Container from '@/components/shared/Container';
import { getFooterItems } from '@/core/lib/api/main/menu-api';
import { getSettings } from '@/core/lib/api/main/setting';
import { MenuItem } from '@/core/types/menuApi';

import FooterList from './FooterList';
import Newsletter from './Newsletter';
import SocialMedia from './SocialMedia';

export default async function Footer() {
    try {
        const setting = await getSettings();
        const footerItems: MenuItem[] = await getFooterItems();

        if (!setting) return null;

        return (
            <footer className="bg-primary-0 border-t border-primary-900 mt-16 print:hidden overflow-hidden">
                <Container className="py-14">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
                        <div className="lg:col-span-4 flex flex-col gap-6">
                            {setting.logo_footer && (
                                <Image
                                    src={setting.logo_footer}
                                    alt={setting.site_title || 'Logo'}
                                    width={120}
                                    height={56}
                                    className="object-contain"
                                />
                            )}
                            {setting.site_description && (
                                <p className="text-[13px] leading-7 text-primary-600 max-w-sm">
                                    {setting.site_description}
                                </p>
                            )}
                            <SocialMedia iconColor="#0a0a09" />
                        </div>

                        <div className="lg:col-span-5 grid grid-cols-2 sm:grid-cols-3 gap-8">
                            <FooterList footerItems={footerItems} setting={setting} />
                        </div>

                        <div className="lg:col-span-3">
                            <Newsletter />
                        </div>
                    </div>

                    <div className="mt-12 pt-6 border-t border-primary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
                        <p className="text-[11px] tracking-wide text-primary-500">
                            © {new Date().getFullYear()} {setting.site_title}. تمامی حقوق محفوظ است.
                        </p>
                        <Link
                            href="/"
                            className="text-[11px] uppercase tracking-[0.14em] text-primary-400"
                        >
                            {setting.site_title}
                        </Link>
                    </div>
                </Container>
            </footer>
        );
    } catch {
        return null;
    }
}